import { useTranslation } from "react-i18next";

import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { useUpdateMaterial } from "#modules/quoteRequestLines/useUpdateMaterial";
import { MaterialSelect } from "#modules/quoteRequestLinesV2/view/molecules/MaterialSelect";
import { AssemblyWithChildren, MaterialGradeType } from "shared";

type Props = {
  line: QuoteRequestLineDto;
  assembly: AssemblyWithChildren<QuoteRequestLineDto>;
};

export const MaterialCell = ({ line, assembly }: Props) => {
  const { updateMaterial } = useUpdateMaterial();
  const { t } = useTranslation();

  const onMaterialChange = (materialName: string, materialGrade: MaterialGradeType | null) => {
    void updateMaterial({
      quoteRequestLineId: line.id,
      predictionStatus: line.predictionStatus,
      payload: { materialName, materialGrade },
    });
  };

  return (
    <MaterialSelect
      quoteRequestLine={line}
      assembly={assembly}
      onChange={onMaterialChange}
      placeholder={t("quoteRequestV2.column.materialPlaceholder")}
    />
  );
};
